import React from 'react';
import { Row, Col, Button, Image } from 'react-bootstrap';

const PrincipalItem = props => {
  return (
    <>
      <div className="slide-mobile">
        <Row>
          <Col xs={12}>
            <h1 className="slide-title mobile-text ">Descubre todo lo que puedes hacer con tu app Claro Pay.</h1>
          </Col>
          <Col xs={12}>
            <Row className="margin-mobile-adjust">
              <Col xs={5}>
                <div className="slide-main-img">
                  <img
                    className="phone"
                    src="images/phone-descubre.png"
                    alt="First slide"
                  />
                </div>
              </Col>
              <Col xs={7} className="content-icons">
                <div className="item-icon-slide">
                  <Image src="images/envio.png" className="icons-slide" />
                  Envía y recibe dinero
                </div>
                <div className="item-icon-slide">
                  <Image src="images/recarga.png" className="icons-slide" />
                  Recarga tiempo aire
                </div>
                <div className="item-icon-slide">
                  <Image src="images/realiza-pagos.png" className="icons-slide" />
                  Realiza pagos en comercios
                </div>
                <div className="item-icon-slide">
                  <Image src="images/paga-servicios.png" className="icons-slide" />
                  Paga tus servicios como agua, luz y gas
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={12} className="container-button">
            <Button variant="button-round btn-red-wite" onClick={props.onClick}> &nbsp; &nbsp; &nbsp;Ver tutorial &nbsp; &nbsp; &nbsp; </Button>
          </Col>
        </Row>
      </div>
      <div className="slide-desktop">
        <Row className="item-slide">
          <Col xs={12} md={6} >
            <div className="slide-main-img">
              <img
                className="phone"
                src="images/phone-descubre.png"
                alt="First slide"
              />
            </div>
          </Col>
          <Col xs={12} md={6} >
            <div className="slide-desc-main">
              <h1 className="slide-title width-title-main" >Descubre todo lo que puedes hacer con tu app Claro Pay.</h1>
              <Row>
                <Col xs={6} className="content-icons">
                  <Image src="images/envio.png" className="icons-slide" />
                  Envía y recibe dinero
                </Col>
                <Col xs={6} className="content-icons">
                  <Image src="images/realiza-pagos.png" className="icons-slide" />
                  Realiza pagos <br />en comercios
                </Col>
              </Row>
              <Row>
                <Col xs={6} className="content-icons">
                  <Image src="images/recarga.png" className="icons-slide" />
                  Recarga tiempo aire
                </Col>
                <Col xs={6} className="content-icons">
                  <Image src="images/paga-servicios.png" className="icons-slide" />
                  Paga tus servicios <br /> como agua, luz y gas
                </Col>
              </Row>
              <Row>
                <Col className="box-btn-carousel" ><Button variant="button-round btn-red-wite btn-paddig-2rem" onClick={props.onClick}> &nbsp; &nbsp; &nbsp;Ver tutorial &nbsp; &nbsp; &nbsp; </Button></Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default PrincipalItem;
